// extracted by mini-css-extract-plugin
export default {"min-screen-size-required":"MinScreenSize_min-screen-size-required__ZsMOg","message":"MinScreenSize_message__F0UAw","logo":"MinScreenSize_logo__TzdoW"};